const BalconyDirection = {
  NORTH: "北",
  NORTH_EAST: "北東",
  EAST: "東",
  SOUTH_EAST: "南東",
  SOUTH: "南",
  SOUTH_WEST: "南西",
  WEST: "西",
  NORTH_WEST: "北西",
  OTHER: "その他",
} as const;

export type IBalconyDirection = typeof BalconyDirection[keyof typeof BalconyDirection];

export const balconyDirectionOptions = Object.values(BalconyDirection).map(value => ({ label: value, value }));

export default BalconyDirection;
